import { deepCopy } from "./common";

const findPriceItem = (d?: PriceOfSingleBookingDTO, t?: TPriceItem) => {
  return d?.priceItems?.find((p) => p.hide && p.name === t);
};
const extractRenderLs = (d?: PriceOfSingleBookingDTO) => {
  return d?.priceItems?.filter((p) => !p.hide);
};
const summary = (
  bookingState: BookingState,
  priceOfBooking?: PriceOfSingleBookingDTO,
) => {
  priceOfBooking = priceOfBooking ? deepCopy(priceOfBooking) : undefined;
  bookingState = deepCopy(bookingState);
  // const { bookingAttributes } = bookingState;

  const fee = findPriceItem(priceOfBooking, "FEE")?.actualAmount ?? 0;

  // List order: PERSON > ADULT > ....
  const piLsRaw = extractRenderLs(priceOfBooking) ?? [];
  // .sort((a, b) => {
  //   const f = (name: string) =>
  //     name === "PERSON" ? 1 : name === "ADULT" ? 2 : 100;
  //   return f(a.name) - f(b.name);
  // });

  // const isPass = bookingState.product?.productType === "PASS";
  const productType = bookingState.product?.productType;
  const piLs = (function () {
    if (productType === "MUSICAL") {
      return piLsRaw.filter((x) => x.name !== "ADULT" && x.name !== "CHILD");
    }
    return piLsRaw.filter(
      (x) => x.name !== "ADULT" && x.name !== "CHILD" && x.name !== "PERSON",
    );
  })();
  let priceIts: PriceItemDp[] = [];
  // if (isPass) {
  //   // * The number of adults may not match the actual selection because children are priced as adults (not configured)
  //   // * 1. RE-DISTRIBUTE the number of ADULT and CHILD to match the actual selection
  //   // * 2. PERSON treats as ADULT and must be RE-DISTRIBUTED
  //   const adultQty = ProdAttrUtils.PASS.findAdultQty(bookingAttributes);
  //   const childQty = ProdAttrUtils.PASS.findChidQty(bookingAttributes);

  //   // * difference between the actual value and the expected value of adults or children to RE-DISTRIBUTE them accordingly.
  //   let diffVal = 0;
  //   for (const pi of piLs) {
  //     const name = pi.name === "PERSON" ? "ADULT" : pi.name;
  //     pi.name = name;
  //     const existing = priceIts.find((x) => name === x.name);
  //     if (existing) {
  //       let qty = (existing.quantity ?? 0) + (pi.quantity ?? 0);
  //       let val = (existing.value ?? 0) + (pi.value ?? 0);
  //       if (name === "ADULT") {
  //         if (adultQty < qty) {
  //           const excessValue = (val / qty) * (qty - adultQty);
  //           val -= excessValue;
  //           diffVal += excessValue;
  //         }
  //         qty = adultQty;
  //       } else if (name === "CHILD") {
  //         qty = childQty;
  //       }
  //       existing.quantity = qty;
  //       existing.value = (existing.value ?? 0) + val;
  //     } else {
  //       priceIts.push(pi);
  //     }
  //   }

  //   if (diffVal) {
  //     const pi = priceIts.find((pi) => pi.name === "CHILD");
  //     if (pi) {
  //       pi.value += diffVal;
  //     }
  //   }
  //   // priceIts = mergeLs(deepCopy(priceIts));
  // } else {
  //   // Gộp các field giống nhau lại
  //   const mergeByNamePriceIts: PriceItemResponseDTO[] = mergeLs(piLs);
  //   priceIts.push(...mergeByNamePriceIts);
  // }

  if (
    priceOfBooking?.ageQuantityPriceLs &&
    productType !== "MUSICAL" &&
    productType !== "SIM"
  ) {
    for (const ageQPrice of priceOfBooking.ageQuantityPriceLs) {
      priceIts.push({
        name: ageQPrice.age,
        actualAmount: ageQPrice.actualAmount,
        actualDiscountAmount: ageQPrice.actualDiscountAmount,
        quantity: ageQPrice.quantity,
        details: [],
      });
    }
  }
  const mergeByNamePriceIts: PriceItemDp[] = mergeLs(piLs);
  priceIts.push(...mergeByNamePriceIts);
  return {
    fee,
    priceIts,
  };
};

const mergeLs = (piLs: PriceItemDp[]) =>
  piLs.reduce((a: PriceItemDp[], pi) => {
    const existing = a.find((x) => {
      if (pi.name === "EXTRA_OPTION") {
        return (
          x.name === pi.name && x.productAttributeId === pi.productAttributeId
        );
      }
      return x.name === pi.name;
    });
    if (existing) {
      existing.quantity = (existing.quantity ?? 0) + (pi.quantity ?? 0);
      existing.actualAmount =
        (existing.actualAmount ?? 0) + (pi.actualAmount ?? 0);
      existing.details = [...existing.details, ...pi.details];
    } else {
      a.push(pi);
    }
    return a;
  }, []);

export const PriceUtils = {
  findPriceItem,
  extractRenderLs,
  summary,
  mergeLs,
};
